import { createTheme } from "@mui/material/styles";
import { defaultTheme } from "react-admin";

const titleFont = '"Modak", system-ui';
const textFont = '"DM Sans", "Roboto", "Arial", sans-serif';

export const lightTheme = createTheme({
  ...defaultTheme,
  palette: {
    mode: "light",
    primary: { main: "#D935FE" },
    secondary: { main: "#6C0088" },
    text: { primary: "#6C0088", secondary: "#000", disabled: "#D935FE" },
    background: { default: "#F9F9F9" },
  },
  typography: {
    fontFamily: textFont,
    h1: { fontFamily: titleFont },
    h2: { fontFamily: titleFont },
    h3: { fontFamily: titleFont },
    h4: { fontFamily: titleFont },
    h5: { fontFamily: textFont },
    h6: { fontFamily: textFont },
  },
});

export const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: { main: "#D935FE" },
    secondary: { main: "#6C0088" },
    text: { primary: "#6C0088" },
  },
  typography: {
    fontFamily: textFont,
    h1: { fontFamily: titleFont },
    h2: { fontFamily: titleFont },
    h3: { fontFamily: titleFont },
    h4: { fontFamily: titleFont },
    h5: { fontFamily: textFont },
    h6: { fontFamily: textFont },
  },
});
